<template>
  <span
    v-if="canEdit"
    class="daily-deal-inline-editor daily-deal-wrapper"
    :class="{ 'is-iphone': isIphone, 'is-mobile': isMobile }"
    v-click-outside="closePopover"
  >
    <button
      type="button"
      class="daily-deal-inline-editor__trigger"
      title="Edit Daily Deal"
      @click.stop="togglePopover"
    >
      <Edit2Icon size="14" />
    </button>

    <transition name="dd-pop">
      <div v-if="open" class="dd-pop" @click.stop>
        <div class="dd-pop__header">
          <div class="dd-pop__header-text">
            <span class="dd-pop__title">
              <CalendarIcon size="14" class="dd-pop__title-icon" />
              Daily Deal
            </span>
            <!-- <span v-if="productName" class="dd-pop__subtitle" :title="productName">{{ productName }}</span> -->
          </div>
          <!-- <button type="button" class="dd-pop__close" aria-label="Close" @click="closePopover">
            <XIcon size="16" />
          </button> -->
        </div>

        <div class="dd-pop__body">
          <!-- <div class="dd-pop__toggle-row"> -->
            <!-- <div class="dd-pop__toggle-label">
              <span class="dd-pop__toggle-title">Active today</span>
               <span class="dd-pop__toggle-hint">Show this product on the Daily Deal page</span>
            </div>
            <b-form-checkbox v-model="form.is_daily_deal" name="dd-toggle" switch size="lg" /> -->
          <!-- </div> -->

          <transition name="dd-fade">
            <div v-if="form.is_daily_deal" class="dd-pop__fields">
              <div class="dd-pop__field">
                <label class="dd-pop__label">
                  <CalendarIcon size="12" />
                  <span>Dealy Deal Date</span>
                  <!-- <span v-if="statusBadge" class="dd-pop__badge" :class="`dd-pop__badge--${statusBadge.type}`">
                    {{ statusBadge.label }}
                  </span> -->
                </label>
                <input
                  ref="dateInput"
                  type="text"
                  class="form-control daily-deal-calendar daily-deal-date-input"
                  placeholder="Pick a date"
                />
              </div>

              <div class="dd-pop__field">
                <label class="dd-pop__label">
                  <DollarSignIcon size="12" />
                  <span>Daily Deal Price</span>
                </label>
                <b-input-group class="dd-pop__price-group">
                  <template #prepend>
                    <span class="input-group-text dd-pop__dollar">$</span>
                  </template>
                  <b-form-input
                    ref="priceInput"
                    v-model="form.daily_deal_price"
                    v-integer-only="{ allowDecimal: true, currencyFormat: true, normalInput: false }"
                    type="text"
                    class="dd-pop__price-input"
                    @keydown.enter.native="save"
                    @keydown.escape.native="closePopover"
                    @focus.native="$event.target.select()"
                  />
                </b-input-group>
                <!-- <div v-if="savingsPercent != null" class="dd-pop__savings">
                  <TagIcon size="10" />
                  Save {{ savingsPercent }}% off regular price
                </div> -->
              </div>
            </div>
          </transition>

          <div v-if="!form.is_daily_deal" class="dd-pop__warning">
            <AlertTriangleIcon size="14" />
            <span>Saving will turn the deal off and remove this product from the Daily Deal page.</span>
          </div>
        </div>

        <div class="dd-pop__footer">
          <button type="button" class="dd-pop__btn dd-pop__btn--ghost" @click="closePopover" :disabled="saving">
            Cancel
          </button>
          <button type="button" class="dd-pop__btn dd-pop__btn--primary" @mousedown.prevent="save" :disabled="saving">
            <span v-if="saving">
              <span class="dd-pop__spinner"></span>
              Saving
            </span>
            <span v-else>
              <CheckIcon size="14" />
              Save
            </span>
          </button>
        </div>
      </div>
    </transition>
  </span>
</template>

<script>
import flatpickr from "flatpickr"
import "flatpickr/dist/flatpickr.css"
import {
  Edit2Icon,
  XIcon,
  CalendarIcon,
  DollarSignIcon,
  TagIcon,
  AlertTriangleIcon,
  CheckIcon
} from "vue-feather-icons"

export default {
  name: "DailyDealInlineEditor",
  components: {
    Edit2Icon,
    XIcon,
    CalendarIcon,
    DollarSignIcon,
    TagIcon,
    AlertTriangleIcon,
    CheckIcon
  },
  props: {
    productId: {
      type: [Number, String],
      required: true
    },
    productName: {
      type: String,
      default: ""
    },
    regularPrice: {
      type: [Number, String],
      default: null
    },
    isDailyDeal: {
      type: [Boolean, Number],
      default: false
    },
    dailyDealDate: {
      type: String,
      default: null
    },
    dailyDealPrice: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      open: false,
      saving: false,
      canEdit: !!(window.Trillion && window.Trillion.canEditDailyDealStorefront)
        && /\/products\/daily-deal(\/|$|\?)/.test(window.location.pathname + window.location.search),
      isIphone: /iPhone/i.test(navigator.userAgent),
      isMobile: !/iPhone|iPad|iPod/i.test(navigator.userAgent)
        && (/Android/i.test(navigator.userAgent) || window.innerWidth < 768),
      flatpickrInstance: null,
      form: {
        is_daily_deal: false,
        daily_deal_date: null,
        daily_deal_price: ""
      }
    }
  },
  computed: {
    statusBadge() {
      if (!this.form.daily_deal_date) return null
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const picked = new Date(this.form.daily_deal_date); picked.setHours(0, 0, 0, 0)
      if (picked > today) return { type: "upcoming", label: "Upcoming" }
      if (picked < today) return { type: "expired", label: "Expired" }
      return { type: "active", label: "Active today" }
    },
    savingsPercent() {
      const regular = parseFloat(this.regularPrice)
      const deal = parseFloat(this.stripCurrencyFormat(this.form.daily_deal_price))
      if (!regular || !deal || deal >= regular) return null
      return Math.round(((regular - deal) / regular) * 100)
    }
  },
  watch: {
    "form.is_daily_deal"(isOn) {
      if (!isOn) {
        this.destroyFlatpickr()
      } else if (this.open) {
        this.$nextTick(() => this.initFlatpickr())
      }
    }
  },
  mounted() {
    this._onOtherDdOpened = (openerUid) => {
      if (openerUid !== this._uid && this.open) {
        this.closePopover()
      }
    }
    this.$root.$on("daily-deal-popup-opened", this._onOtherDdOpened)
  },
  beforeDestroy() {
    this.destroyFlatpickr()
    if (this._onOtherDdOpened) {
      this.$root.$off("daily-deal-popup-opened", this._onOtherDdOpened)
    }
  },
  methods: {
    togglePopover() {
      if (this.open) {
        this.closePopover()
      } else {
        this.openPopover()
      }
    },
    openPopover() {
      this.$root.$emit("daily-deal-popup-opened", this._uid)
      this.form.is_daily_deal = !!this.isDailyDeal
      this.form.daily_deal_date = this.dailyDealDate ? String(this.dailyDealDate).slice(0, 10) : null
      this.form.daily_deal_price = this.dailyDealPrice != null
        ? parseFloat(this.dailyDealPrice).toFixed(2)
        : ""
      this.open = true
      if (this.form.is_daily_deal) {
        this.$nextTick(() => this.initFlatpickr())
      }
    },
    closePopover() {
      this.destroyFlatpickr()
      this.open = false
    },
    initFlatpickr() {
      if (!this.$refs.dateInput) return
      this.destroyFlatpickr()
      const isSmallViewport = this.isIphone || window.innerWidth < 768
      this.flatpickrInstance = flatpickr(this.$refs.dateInput, {
        static: true,
        disableMobile: this.isIphone,
        showMonths: isSmallViewport ? 1 : 3,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "M j, Y",
        altInputClass: "form-control daily-deal-calendar daily-deal-date-input",
        defaultDate: this.form.daily_deal_date || null,
        locale: {
          weekdays: {
            shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          }
        },
        onReady: (selectedDates, dateStr, instance) => {
          // On Android, flatpickr falls back to native <input type="date"> (isMobile=true)
          // and doesn't create a calendarContainer — guard every access to avoid throws
          // that would be swallowed by flatpickr's try/catch and leave us with an empty array
          // instead of an instance (then [].destroy is not a function).
          if (instance.calendarContainer) {
            instance.calendarContainer.classList.add("daily-deal-calendar-popup")
          }
          if (this.isIphone && !this.form.daily_deal_date) {
            instance.clear(false)
          }
          if (this.isIphone) {
            const input = instance.altInput || instance.input
            input.addEventListener("click", function () {
              if (!instance.isOpen) instance.open()
            })
          }
          this.$nextTick(() => this.alignCalendarToViewport())
        },
        onOpen: (selectedDates, dateStr, instance) => {
          if (this.isIphone && selectedDates.length === 0) {
            instance.clear(false)
          }
          if (typeof instance.jumpToDate === "function") {
            instance.jumpToDate(new Date())
          }
          this.$nextTick(() => this.alignCalendarToViewport())
        },
        onChange: (selectedDates, dateStr) => {
          this.form.daily_deal_date = dateStr || null
        }
      })
      window.addEventListener("resize", this.alignCalendarToViewport)
    },
    alignCalendarToViewport() {
      const cal = this.flatpickrInstance && this.flatpickrInstance.calendarContainer
      if (!cal) return
      cal.style.marginLeft = ""
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth
      const rect = cal.getBoundingClientRect()
      const overflow = rect.right - viewportWidth
      if (overflow > 0) {
        cal.style.marginLeft = `-${Math.ceil(overflow)}px`
      }
    },
    destroyFlatpickr() {
      window.removeEventListener("resize", this.alignCalendarToViewport)
      const inst = this.flatpickrInstance
      this.flatpickrInstance = null
      // flatpickr() returns [] if init threw inside its internal try/catch — guard the call
      // so closePopover() is never interrupted by a TypeError (which previously prevented
      // `this.open = false` from running and made Cancel/X appear broken on Android).
      if (inst && typeof inst.destroy === "function") {
        try { inst.destroy() } catch (e) { /* flatpickr destroy is best-effort */ }
      }
    },
    stripCurrencyFormat(value) {
      return String(value == null ? "" : value).replace(/,/g, "")
    },
    save() {
      if (this.saving) return

      const payload = {
        is_daily_deal: this.form.is_daily_deal ? 1 : 0
      }

      if (this.form.is_daily_deal) {
        if (!this.form.daily_deal_date) {
          this.$errorNotify("Please pick a daily deal date.")
          return
        }
        const price = parseFloat(this.stripCurrencyFormat(this.form.daily_deal_price))
        if (isNaN(price) || price < 0.01 || price > 100000) {
          this.$errorNotify("Invalid price. Must be between $0.01 and $100,000.")
          return
        }
        payload.daily_deal_date = this.form.daily_deal_date
        payload.daily_deal_price = price
      } else {
        const confirmed = window.confirm(
          `Turn off today's daily deal for "${this.productName}"? The product will disappear from the Daily Deal page.`
        )
        if (!confirmed) return
      }

      this.saving = true

      $.ajax({
        method: "PUT",
        url: `${window.Trillion.baseUrl}/products/${this.productId}/inline-daily-deal`,
        data: payload
      })
        .then((response) => {
          const data = response.data || {}
          this.closePopover()
          this.$successNotify("Daily deal updated")
          this.$root.$emit("daily-deal-updated", this.productId)

          if (data.is_daily_deal_today) {
            this.$emit("daily-deal-updated", data)
          } else {
            this.$emit("daily-deal-removed", this.productId)
          }
        })
        .catch((xhr) => {
          const msg = xhr.responseJSON ? xhr.responseJSON.message : "Failed to update daily deal"
          this.$errorNotify(msg)
        })
        .always(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style>
:root {
  --flatpickr-scale: 0.85;
}

.flatpickr-calendar.daily-deal-calendar-popup {
  font-size: calc(14px * var(--flatpickr-scale));
  transform: scale(var(--flatpickr-scale));
  transform-origin: top left;
  width: max-content;
  right: initial !important;
  animation: none !important;
}

.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-current-month input.cur-year {
  font-weight: bold !important;
}

.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-weekday {
  color: #000 !important;
  font-weight: bold !important;
}

.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.prevMonthDay,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.nextMonthDay {
  display: block !important;
  visibility: visible !important;
  color: #999 !important;
  opacity: 0.6;
}

.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.prevMonthDay:hover,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.nextMonthDay:hover {
  background: #f0f0f0;
  border-color: #f0f0f0;
}

/* Highlight today's date with a red outline (default text color) */
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today:hover,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today:focus {
  border: 2px solid #dc3545 !important;
  background: transparent !important;
  color: #393939 !important;
}

/* When today is also the selected date: blue fill, white text, red border */
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today.selected,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today.selected:hover,
.flatpickr-calendar.daily-deal-calendar-popup .flatpickr-day.today.selected:focus {
  border: 2px solid #dc3545 !important;
  background: #569ff7 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.flatpickr-calendar.static.daily-deal-calendar-popup {
  z-index: 999999;
}

.daily-deal-wrapper .flatpickr-wrapper {
  position: relative;
}

.daily-deal-date-input {
  height: 29px !important;
  /* width: 130px; */
  background-color: white !important;
  text-align: center;
}

.is-iphone .daily-deal-date-input,
.is-mobile .daily-deal-date-input {
  height: 40px !important;
  width: 100%;
  min-width: 170px;
  font-size: 16px;
  text-align: left !important;
}
</style>

<style lang="scss">
$dd-gold: #DEAA5E;
$dd-gold-dark: #c9952e;
$dd-gold-light: #f7e4b8;
$dd-text: #1f2937;
$dd-muted: #6b7280;
$dd-border: #e5e7eb;
$dd-bg-soft: #fafafa;

.daily-deal-inline-editor {
  position: relative;
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;

  &__trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 50%;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: #ffffff;
      border-color: #ffffff;
      color: $dd-gold;
      transform: scale(1.08);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
    }
  }
}

.dd-pop {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: 210px;
  max-width: 92vw;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.08);
  color: $dd-text;
  overflow: visible;
  text-align: left;

  // Arrow pointing up to the trigger
  &::before {
    content: "";
    position: absolute;
    top: -7px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 14px;
    height: 14px;
    background: linear-gradient(135deg, #{$dd-gold} 0%, #{$dd-gold-dark} 100%);
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    padding: 14px 16px 12px;
    background: linear-gradient(135deg, $dd-gold 0%, $dd-gold-dark 100%);
    color: #ffffff;
    border-radius: 12px 12px 0 0;
  }

  &__header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  &__title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    line-height: 1;
  }

  &__title-icon {
    opacity: 0.9;
  }

  &__subtitle {
    display: block;
    font-size: 12px;
    font-weight: 500;
    opacity: 0.92;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }

  &__close {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    padding: 0;
    background: rgba(255, 255, 255, 0.18);
    border: none;
    border-radius: 50%;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;

    &:hover { background: rgba(255, 255, 255, 0.32); }
    &:focus { outline: none; box-shadow: 0 0 0 2px rgba(255,255,255,0.4); }
  }

  &__body {
    padding: 14px 16px 4px;
  }

  &__toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    margin-bottom: 12px;
    background: $dd-bg-soft;
    border: 1px solid $dd-border;
    border-radius: 8px;
  }

  &__toggle-label {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.25;
  }

  &__toggle-title {
    font-size: 13px;
    font-weight: 600;
    color: $dd-text;
  }

  &__toggle-hint {
    font-size: 11px;
    color: $dd-muted;
  }

  &__fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    color: $dd-muted;
    text-transform: uppercase;
    letter-spacing: 0.04em;

    svg { color: $dd-gold; }
  }

  &__badge {
    margin-left: auto;
    padding: 2px 8px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border-radius: 999px;

    &--active   { background: #dcfce7; color: #166534; }
    &--upcoming { background: #fef3c7; color: #92400e; }
    &--expired  { background: #f3f4f6; color: #6b7280; }
  }

  &__price-group {
    flex-wrap: nowrap;

    .input-group-text {
      padding: 4px 10px;
      font-weight: 700;
      font-size: 14px;
      background: #fff;
      border: 1px solid $dd-border;
      border-right: none;
      color: $dd-gold;
      border-radius: 8px 0 0 8px !important;
    }
  }

  &__dollar { font-weight: 700; color: $dd-gold; }

  &__price-input {
    height: 34px !important;
    padding: 6px 10px;
    border: 1px solid $dd-border;
    border-radius: 0 8px 8px 0 !important;
    font-size: 14px;
    font-weight: 600;
    color: $dd-text;
    outline: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: $dd-gold;
      box-shadow: 0 0 0 3px rgba(222, 170, 94, 0.2);
    }
  }

  &__savings {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    padding: 3px 8px;
    font-size: 11px;
    font-weight: 600;
    color: #047857;
    background: #d1fae5;
    border-radius: 6px;
    width: fit-content;

    svg { color: #047857; }
  }

  &__warning {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.4;
    color: #7c2d12;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;

    svg {
      flex-shrink: 0;
      margin-top: 1px;
      color: #dc2626;
    }
  }

  &__footer {
    display: flex;
    gap: 8px;
    padding: 12px 16px 14px;
    border-top: 1px solid $dd-border;
    margin-top: 12px;
    background: $dd-bg-soft;
    border-radius: 0 0 12px 12px;
  }

  &__btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 36px;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &--primary {
      flex: 1.6;
      color: #ffffff;
      background: linear-gradient(135deg, $dd-gold 0%, $dd-gold-dark 100%);
      box-shadow: 0 2px 6px rgba(222, 170, 94, 0.35);

      &:not(:disabled):hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 10px rgba(222, 170, 94, 0.45);
      }

      &:focus { outline: none; box-shadow: 0 0 0 3px rgba(222, 170, 94, 0.35); }
    }

    &--ghost {
      color: $dd-muted;
      background: transparent;
      border-color: $dd-border;

      &:not(:disabled):hover {
        color: $dd-text;
        background: #f3f4f6;
      }
    }
  }

  &__spinner {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: dd-spin 0.7s linear infinite;
  }

  // Bootstrap-Vue switch tweaks to make it a bit bigger + gold
  .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $dd-gold;
    border-color: $dd-gold;
  }
  .custom-switch .custom-control-label { cursor: pointer; }
}

@keyframes dd-spin {
  to { transform: rotate(360deg); }
}

// Entrance animation
.dd-pop-enter-active { transition: opacity 0.15s ease, transform 0.2s cubic-bezier(0.2, 0.9, 0.3, 1.2); }
.dd-pop-leave-active { transition: opacity 0.12s ease, transform 0.12s ease; }
.dd-pop-enter,
.dd-pop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px) scale(0.96);
}

// Inner field fade
.dd-fade-enter-active, .dd-fade-leave-active { transition: opacity 0.15s ease, max-height 0.2s ease; }
.dd-fade-enter, .dd-fade-leave-to { opacity: 0; max-height: 0; overflow: hidden; }
.dd-fade-enter-to, .dd-fade-leave { opacity: 1; max-height: 300px; }
</style>
